// extracted by mini-css-extract-plugin
export default {"imageContainer":"styles_imageContainer__yrqqF","image":"styles_image__x5O2r"};